import { ReactElement } from "react";
import {
  AddressFieldConfig,
  CountryFieldConfig,
} from "@evergiving/common/dist/es2015/form";
import { FreeFormAddressComponent } from "@/lib/components/FreeFormAddressComponent";
import { useSelector } from "react-redux";
import { RootState } from "@/lib/redux/types";
import { AddressFieldWithSearch } from "./AddressFieldWithSearch";

export function AddressField({
  locale,
  countryFieldConfig,
  addressFieldConfig,
  defaultCountryCode,
}: {
  locale: string;
  countryFieldConfig: CountryFieldConfig | undefined;
  addressFieldConfig: AddressFieldConfig;
  defaultCountryCode: string;
}): ReactElement | null {
  const currentCountryCode = useSelector(
    (state: RootState) => state.countryCode.value
  );

  if ("melissa" in addressFieldConfig) {
    return (
      <AddressFieldWithSearch
        locale={locale}
        countryFieldConfig={countryFieldConfig}
        addressFieldConfig={addressFieldConfig}
        defaultCountryCode={defaultCountryCode}
      />
    );
  }
  return (
    <FreeFormAddressComponent
      freeFormAddressFieldConfig={
        (currentCountryCode
          ? addressFieldConfig.freeForm.byCountry[currentCountryCode]
          : undefined) ?? addressFieldConfig.freeForm.defaultConfig
      }
    />
  );
}
